export default __webpack_public_path__ + "locales/es/ResetApplicationDialog.json?hash=7c9645233e0b9bcc23182cc7e9f7d56c";